import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { SessionStateService } from '../../../services/session-state.service';
import { DocumentService, mapToSearchIndexDocument } from '../../../services/document.service';
import { filter, map } from 'rxjs/operators';
import { type FirestoreComment, FirestoreUser } from '@jessie/commons';
import { DocumentSlideOverComponent } from '../../document/document-slide-over/document-slide-over.component';
import { Dialog } from '@angular/cdk/dialog';
import { CommentService } from '../../../services/comment.service';
import { AsyncPipe, DatePipe } from '@angular/common';
import { NgIconWrapperComponent } from '../../../components/icons/ng-icon-wrapper/ng-icon-wrapper.component';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-comment-page',
  imports: [AsyncPipe, NgIconWrapperComponent, DatePipe],
  templateUrl: './my-comments.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyCommentsPage {
  notReactedComments = this.commentService.getNotReactedComments();

  loggedInUserId = this.sessionState.getUser().pipe(
    filter((user): user is FirestoreUser => !!user),
    map((user) => user.id)
  );

  constructor(
    private documentService: DocumentService,
    private sessionState: SessionStateService,
    private commentService: CommentService,
    private router: Router,
    @Inject(Dialog) private dialog: Dialog
  ) {}

  async ngOnInit() {
    const notReacted = await firstValueFrom(this.notReactedComments);
    if (notReacted?.length === 0) {
      this.router.navigate(['/']);
    }
  }

  async openCommentedEntity(comment: FirestoreComment) {
    let parentEntity = comment.data.parentEntity;
    let parentId = comment.data.parentId;

    // Infer from docRef path for older comments missing parentEntity/parentId
    if (!parentEntity) {
      const segments = comment.docRef.path.split('/');
      const commentIndex = segments.lastIndexOf('comment');
      if (commentIndex >= 2) {
        parentEntity = segments[commentIndex - 2] as typeof parentEntity;
        parentId = segments[commentIndex - 1];
      }
    }

    switch (parentEntity) {
      case 'document':
        const document = await firstValueFrom(
          this.documentService.getDocument(parentId)
        );
        this.dialog.open(DocumentSlideOverComponent, {
          data: { documents: [mapToSearchIndexDocument(document)] },
        });
        break;
      case 'customer':
        this.router.navigate(['/customer/', parentId]);
        break;

      case 'invoice':
        this.router.navigate(['/project/invoice/', parentId]);
        break;
      case 'project':
        this.router.navigate(['/project/details/', parentId, 'comments']);
        break;
    }
  }
}
